import { initLogging } from "@expert/logging";
import { env } from "@/config";

initLogging({
    appName: env.appName,
    commitHash: env.commitHash,
    logLevel: env.logLevel,
    channel: env.channel,
    isConsoleLogEnabled: !env.disableConsoleLogs,
});
